import { useNavigate } from '@tanstack/react-router';
import { SandboxList } from '@frontend/wam-sales-demo-service';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function SalesDemoSandboxes() {
  const navigate = useNavigate();
  return (
    <Page
      title='Sales Demo - Sandboxes'
      breadcrumbs={[{ label: 'Global Settings' }, { label: 'Sales Demo' }, { label: 'Sandboxes' }]}
      maxWidth='100%'
    >
      <Container>
        <SandboxList
          onSelectSandbox={(sandboxId) =>
            navigate({
              to: '/global-settings/sales-demo-sandboxes/$sandboxId' as any,
              params: { sandboxId } as any,
            })
          }
        />
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/sales-demo-sandboxes',
  component: SalesDemoSandboxes,
  type: 'auth',
  locationRequired: false,
});
